module.exports = __webpack_public_path__ + "img/2_4_redeem.2c933eb7.gif";